import { render, staticRenderFns } from "./ChangePasswordDialog.vue?vue&type=template&id=49b878d6&scoped=true&lang=html&"
import script from "./ChangePasswordDialog.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b878d6",
  null
  
)

export default component.exports